import { clearPersistedOverlays } from '../../../../ui-lib/modules/Map/map-tools/OverlaysMapTool/hooks/useOverlaysMapTool';

const DRIVING_BEHAVIOR = {
  TOTAL_RISK_EVENTS_CHART_TYPE: 'truckshieldTotalRiskEventsChartType',
};
const TOTAL_EVENT_COUNT = 'total_event_count';

const clearReduxPersistedState = () => {
  localStorage.removeItem('persist:root');
};

export const clearLocalStorage = () => {
  localStorage.removeItem(DRIVING_BEHAVIOR.TOTAL_RISK_EVENTS_CHART_TYPE);
  localStorage.removeItem(TOTAL_EVENT_COUNT);
  localStorage.removeItem('appVersion');
  clearPersistedOverlays();
  clearReduxPersistedState();
};

const generateCodeChallenge = async (codeVerifier: string) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(codeVerifier);
  const digest = await window.crypto.subtle.digest('SHA-256', data);

  return window.btoa(String.fromCharCode(...new Uint8Array(digest)))
    .replace(/=/g, '')
    .replace(/\+/g, '-')
    .replace(/\//g, '_');
};

const createRandomString = (length: number) => {
  const chars =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const randomArray = new Uint8Array(length);
  crypto.getRandomValues(randomArray);
  return randomArray.reduce((result, number) => {
    return (result += chars[number % chars.length]);
  }, '');
};

export const getCodeChallenge = () => {
  const codeVerifier = createRandomString(43);
  sessionStorage.setItem('codeVerifier', codeVerifier);
  return generateCodeChallenge(codeVerifier);
};

export const getCodeVerifier = () => {
  const codeVerifier = sessionStorage.getItem('codeVerifier');
  sessionStorage.removeItem('codeVerifier');
  return codeVerifier;
};
